import { I04CALCULGDETAItem_State } from '@batical/types/src'

const I04CALCULGDETAItem: I04CALCULGDETAItem_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  category: '',
  item_uuid: '',
  in_namePart: '',
  m_lourd_nature: '0',
  in_m_lourd_epaisseur: 0.0,
  vitrage_uuid: '0',
  iso_nature: '0',
  in_iso_epaisseur: 0.0,
  in_iso_position: 0,
  in_paroi_position: 0,
  in_plancher_position: 'pos_plancher_0',
  in_plafond_position: 'pos_plafond_0',
  in_ucorr: 0.0,
  in_superficie: 0.0,
  orientation_uuid: 'orientation_N',
  res_vitrage_orientation: 0.0,
  res_ucalc: 0.0,
  vitrage_facade_uuid: '',
  mode: 'none',
  calcul_code: 'I04CALCULGDETAItem'
}

export const I04CALCULGDETAItemFacade: I04CALCULGDETAItem_State = {
  ...I04CALCULGDETAItem,
  category: 'facades',
  in_namePart: 'Façade 1',
  m_lourd_nature: 'MEXT3',
  iso_nature: 'ilosant0'
}

export const I04CALCULGDETAItemPlafond: I04CALCULGDETAItem_State = {
  ...I04CALCULGDETAItem,
  category: 'plafonds',
  in_namePart: 'Plafond 1',
  m_lourd_nature: 'PLAFOND0',
  iso_nature: 'ilosant0'
}

export const I04CALCULGDETAItemPlancher: I04CALCULGDETAItem_State = {
  ...I04CALCULGDETAItem,
  category: 'planchers',
  in_namePart: 'Plancher 1',
  m_lourd_nature: 'Plancher0',
  iso_nature: 'ilosant0'
}

export const I04CALCULGDETAItemPorte: I04CALCULGDETAItem_State = {
  ...I04CALCULGDETAItem,
  category: 'portes',
  in_namePart: 'Porte 1',
  m_lourd_nature: 'Porte0',
  iso_nature: ''
}

export const I04CALCULGDETAItemVitrage: I04CALCULGDETAItem_State = {
  ...I04CALCULGDETAItem,
  category: 'vitrages',
  in_namePart: 'Vitrage 1',
  m_lourd_nature: '',
  vitrage_uuid: 'Vitrage0',
  iso_nature: ''
}

export default I04CALCULGDETAItem
